var _defs, _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "die_line",
    "data-name": "die line",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1984 1984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1789.94,540.93c-6.7-36.69-17.89-72.2-34.16-104.69-8.48-16.93-18.27-33.1-28.31-42.75-9.52-9.16-20.1-17.17-31.42-22.27-45.29-20.36-103.73-30.57-175.27-30.57-52.48,0-79.45,.5-115.02,11.6-23.49,7.33-57.56,17.96-88.45,47.8-42.64,41.18-52.59,93.23-55.4,115.5,0,0-113.58,669.62-140.39,759.93h-10.96l-170.55-760.84c-12.6-55.56-43.69-103.81-87.42-131.57-1.96-1.24-3.95-2.46-5.97-3.63-2.36-1.38-4.76-2.71-7.19-4-43.82-23.18-104.44-34.78-181.84-34.78h-178.13c-33.21,2.01-59.61,33.61-59.61,72.32s28.15,72.37,62.89,72.42c-.03,0-.05,0-.07,0h72.68c39.96,0,72.36,32.39,72.36,72.36v.03c0,39.96-32.4,72.36-72.36,72.36h-32.38s.05,0,.08,0c-36.22,.05-65.56,32.43-65.56,72.37s29.35,72.32,65.56,72.37c-.03,0-.05,0-.08,0h68.3c39.96,0,72.36,32.39,72.36,72.36v.03c0,39.96-32.4,72.36-72.36,72.36h-122.07s.05,0,.08,0c-34.74,.05-62.89,32.43-62.89,72.37s28.15,72.32,62.89,72.37c-.02,0-.05,0-.07,0h81.12c39.96,0,72.36,32.39,72.36,72.36v.03c0,39.96-32.39,72.36-72.36,72.36h-196.29s.05,0,.07,0c-34.74,.05-62.89,32.43-62.89,72.37s28.15,72.32,62.89,72.37c-.03,0-.05,0-.07,0h45.52c39.96,0,72.36,32.4,72.36,72.36v.03c0,39.96-32.39,72.36-72.36,72.36H212.47s.05,0,.07,0c-34.74,.05-62.89,32.43-62.89,72.37s28.15,72.32,62.89,72.37c-.03,0-.05,0-.07,0h155.4s117.38,0,117.38,0h10.25c11.89-.46,27.97-2.68,45.41-9.99,27-11.32,42.64-28.69,50.62-37.76,7.47-8.49,21.67-26.53,30.46-53.17,2.5-7.56,4.42-15.4,5.72-23.46l117.83-731.43h10.95l133.55,660.23,15.81,78.17c3.05,15.09,7.68,29.86,14.4,43.71,7.77,16,18.43,31.63,33.67,41.1,21.03,13.07,51.59,25.12,94.5,27.97l73.1-.68c39.43,0,74.11-4.54,104.06-13.7,.3-.09,.6-.18,.9-.27,43.92-13.54,77.02-49.85,87.58-94.58,46.83-198.41,134.54-693.09,147.57-741.95h10.95c41.41,233.87,124.22,701.61,124.22,701.61,15.19,80.1,26.94,104.05,67.17,125.59,22.09,11.83,46.21,19.3,70.97,23.15,18.31,2.85,41.95,5.46,67.13,5.46,42.35,0,77.02-3.16,104.06-9.49,27.01-6.32,52.92-16.5,77.77-30.57l-193.99-1062.35Zm-961.13,16.84c0,39.97-32.4,72.37-72.37,72.37h-20.43c-39.97,0-72.37-32.4-72.37-72.37h0c0-39.97,32.4-72.37,72.37-72.37h20.43c39.97,0,72.37,32.4,72.37,72.37h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.82,
    y: 340.66,
    width: 233.59,
    height: 144.74,
    rx: 72.36,
    ry: 72.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.19,
    y: 630.14,
    width: 233.59,
    height: 144.74,
    rx: 72.37,
    ry: 72.37
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.08,
    y: 630.14,
    width: 144.74,
    height: 144.74,
    rx: 72.37,
    ry: 72.37
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.52,
    y: 919.58,
    width: 322.06,
    height: 144.74,
    rx: 72.36,
    ry: 72.36
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.5f5d81c224cdfb4e6decfe1a57652815.svg";
export { ForwardRef as ReactComponent };